module.exports = __webpack_public_path__ + "img/logo-eleva-branco.35df70e7.png";